module.exports = __webpack_public_path__ + "static/media/preloader-6.1bcae76c.gif";